import { AppointmentsRepository } from "@/repositories/appointments.repository";
import { appointment_status } from "@/models/appointment.model";

export async function listIndividualAppointments(
  page: number,
  pageSize: number,
  filters: {
    status?: appointment_status;
    serviceParent?: string;
    search?: string;
    dateFrom?: string;
    dateTo?: string;
  },
  sortKey: string,
  sortOrder: "asc" | "desc"
) {
  return AppointmentsRepository.listForIndividual(page, pageSize, filters, sortKey, sortOrder);
}

export const listIndividualAppointmentFilterOptions = async () => {
  return AppointmentsRepository.listFilterOptionsForIndividual();
};

// New subs appointments functions
export async function listSubsAppointments(
  page: number,
  pageSize: number,
  filters: {
    status?: appointment_status;
    serviceParent?: string;
    search?: string;
    dateFrom?: string;
    dateTo?: string;
  },
  sortKey: string,
  sortOrder: "asc" | "desc"
) {
  return AppointmentsRepository.listForSubs(page, pageSize, filters, sortKey, sortOrder);
}

export const listSubsAppointmentFilterOptions = async () => {
  return AppointmentsRepository.listFilterOptionsForSubs();
};

// Detail page functions
export const fetchIndividualAppointment = (id: string) => AppointmentsRepository.getById(id);
export const fetchIndividualAppointmentLogs = (id: string) => AppointmentsRepository.listHistory(id);
